import { apiSlice } from '../apiSlice';
import { DeleteResponse } from '../schemas/apiResponse';
import { Block } from '../schemas/block';
import { Collection } from '../schemas/collection';

import { PaginatedArgs, PaginatedResponse } from '../schemas/pagination';
import { filterParamsAdapter } from '../utils/filterParamsAdapter';
import { providesList } from '../utils/providesList';

type CollectionFilterParams = {
  id__in?: string[];
  thru_date__isnull?: boolean;
  ranch__id__in?: string[];
  ranch__name__like?: string[];
  customer__id__in?: string[];
  customer__short_code__in?: string[];
};

const COLLECTIONS_PATH = '/collections';

//TODO: Update endpoint function contents. The current logic is copy/pasted from blocks.ts
const collectionEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCollections: builder.query<
      Collection[],
      (CollectionFilterParams & PaginatedArgs) | void
    >({
      query: (params) => ({
        url: COLLECTIONS_PATH,
        params: params ? filterParamsAdapter(params) : undefined,
      }),
      providesTags: (result) => providesList(result, 'Collection'),
    }),
    getCollection: builder.query<Collection, string>({
      query: (id) => `${COLLECTIONS_PATH}/${id}`,
      providesTags: (result, error, id) => [{ type: 'Collection', id }],
    }),
    deleteCollection: builder.mutation<DeleteResponse, string>({
      query(id) {
        return {
          url: `${COLLECTIONS_PATH}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, id) => [{ type: 'Collection', id }],
    }),
    getBlocksForCollection: builder.query<
      PaginatedResponse<Block>,
      Collection['id']
    >({
      query: (id) => `${COLLECTIONS_PATH}/${id}/blocks`,
      providesTags: (result) => providesList(result?.items, 'Block'),
    }),
  }),
});

export const {
  useGetAllCollectionsQuery,
  useGetCollectionQuery,
  useDeleteCollectionMutation,
  useGetBlocksForCollectionQuery,
} = collectionEndpoints;
